module.exports = __webpack_public_path__ + "static/media/green_heroes.17bd8e9e.png";